<template>
  <div class="p-6 min-w-min h-full flex flex-col bg-white rounded-2xl">
    <!-- title and search bar -->
    <div class="flex flex-row items-center justify-between">
      <p class="text-3xl font-bold">Request Update</p>
      <div class="flex flex-row items-center justify-between space-x-4">
        <div class="relative group">
          <input type="text" v-model="searchText" class="bg-light-gray px-4 py-3 rounded-full font-sans"
            placeholder="Search for members" v-on:keyup.enter="handleSearch" />
          <MagnifyingGlassIcon class="absolute bottom-3 right-3 w-6 h-6 text-gray" />
        </div>
      </div>
    </div>
    <!-- body -->
    <div>
      <table class="table-auto w-full font-light">
        <thead class="border-b-2 border-light-gray">
          <tr class="text-left text-gray text-lg">
            <th class="py-2 font-normal">Profile</th>
            <th class="py-2 font-normal">Name</th>
            <th class="py-2 font-normal">Gender</th>
            <th class="py-2 font-normal">Date of Brith</th>
            <th class="py-2 font-normal">Phone</th>
            <th class="py-2 font-normal">Email</th>
            <th class="py-2 font-normal text-center">Status</th>
            <th class="py-2 font-normal text-center">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="member in members" :key="member.id" class="text-lg">
            <td>
              <img class="rounded-full w-14 h-14 object-cover my-2" :src="member.profile" alt="" />
            </td>
            <td>{{ member.first_name }} {{ member.last_name }}</td>
            <td>
              <p v-if="member.gender == '0'">Male</p>
              <p v-else>Female</p>
            </td>
            <td>{{ moment(member.dob).format("DD MMMM YYYY") }}</td>
            <td>{{ member.phone_number }}</td>
            <td>{{ member.email }}</td>
            <!-- member status -->
            <td>
              <div class="flex justify-center">
                <div v-if="member.reason" class="px-4 py-1 bg-light-red text-red rounded-full w-max">
                  <p>Rejected</p>
                </div>
                <div v-else class="px-4 py-1 bg-light-blue text-blue rounded-full w-max">
                  <p>Pending</p>
                </div>
              </div>
            </td>
            <td>
              <div class="flex justify-center relative">
                <Menu>
                  <MenuButton>
                    <EllipsisVerticalIcon class="w-8 h-8 text-black hover:text-blue cursor-pointer" />
                  </MenuButton>
                  <MenuItems
                    class="p-1 space-y-1 absolute top-8 right-8 z-50 bg-white border border-light-gray shadow-md rounded-lg w-12/12">
                    <MenuItem @click="handleViewSlideOver(member)"
                      class="hover:bg-light-blue m-1 rounded-md cursor-pointer">
                    <div class="flex flex-row items-center px-4 py-2 min-w-max">
                      <EyeIcon class="text-blue w-5 h-5 mr-4" />
                      <p class="text-blue">View Request Update Detail</p>
                    </div>
                    </MenuItem>
                    <MenuItem @click="handleConfirmUpdate(member.id)"
                      class="hover:bg-light-blue m-1 rounded-md cursor-pointer">
                    <div class="flex flex-row items-center px-4 py-2 min-w-max">
                      <UserPlusIcon class="text-blue w-5 h-5 mr-4" />
                      <p class="text-blue">Confirm Update</p>
                    </div>
                    </MenuItem>
                    <MenuItem @click="handleRejectSlideOver(member.id)" v-if="!member.reason"
                      class="hover:bg-light-blue m-1 rounded-md cursor-pointer">
                    <div class="flex flex-row items-center px-4 py-2 min-w-min">
                      <UserMinusIcon class="text-red w-5 h-5 mr-4" />
                      <p class="text-red">Reject</p>
                    </div>
                    </MenuItem>
                  </MenuItems>
                </Menu>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <!-- loading animation -->
      <div class="min-h-full flex flex-col space-y-4 items-center justify-center mt-24" v-if="isLoading">
        <div class="animate-ping w-12 h-12 bg-light-gray rounded-full"></div>
        <p class="text-gray text-lg font-sans font-light">Loading data</p>
      </div>
      <!-- no data icon -->
      <div class="min-h-full flex items-center justify-center mt-24" v-if="!members.length && !isLoading">
        <div class="flex flex-col">
          <div class="flex justify-center">
            <InboxIcon class="text-gray w-12 h-12 md:w-24 md:h-24" />
          </div>
          <p class="text-gray text-2xl font-sans font-light">No data found!</p>
        </div>
      </div>
    </div>
    <div class="mt-auto flex justify-end">
      <BasePagination :pageCount="membersMeta.last_page" @navigate-to-page="handlePagination($event)" />
    </div>
  </div>
  <!-- reject update slide over -->
  <SideBar v-show="rejectSlideOver" @close-modal="handleRejectSlideOver">
    <div class="w-full min-h-screen flex flex-col content-between">
      <h1 class="text-blue text-2xl">Reject Update Reason</h1>
      <div class="flex flex-col space-y-4 py-8">
        <base-text-input v-model="reason" name="reason" isAutoComplete="off" label="Reason" />
        <base-text-input disabled v-model="note" name="note" isAutoComplete="off" label="Note" />
      </div>
      <!-- action button -->
      <div class="flex flex-row items-center justify-between space-x-4 mt-auto mb-12">
        <BaseRoundedButton @click="handleRejectSlideOver('')" class="bg-dark-gray w-2/6">
          Cancel
        </BaseRoundedButton>
        <BaseRoundedButton @click="handleRejectUpdate" class="w-4/6">
          Reject Update
        </BaseRoundedButton>
      </div>
    </div>
  </SideBar>
  <!-- view detail Slide over -->
  <SideBar v-show="viewSlideOver" @close-modal="handleCloseViewSlideOver()">
    <div class="w-full h-full flex flex-col content-between">
      <h1 class="text-blue text-2xl">Request Update Detail</h1>
      <div class="pt-2 border-b border-light-gray"></div>
      <div class="flex flex-col space-y-4 py-4">
        <div class="grid grid-cols-2">
          <div class="text-gray line-through">Current Information</div>
          <div class="text-blue">Request Update</div>
        </div>
        <div v-for="(data, index) in tempData" :key="index">
          <template v-if="data.key == 'gender'">
            <div v-if="data.old != data.new" class="p-3 bg-light-gray rounded-xl">
              <p class="pb-2">{{ formatTitleString(data.key) }}</p>
              <div class="grid grid-cols-2">
                <div class="text-gray line-through">
                  <div v-if="data.old == 0">Male</div>
                  <div v-else-if="data.old == 1">Female</div>
                  <div v-else>Other</div>
                </div>
                <div class="text-blue">
                  <div v-if="data.new == 0">Male</div>
                  <div v-else-if="data.new == 1">Female</div>
                  <div v-else>Other</div>
                </div>
              </div>
            </div>
          </template>
          <template v-else-if="data.key == 'public_info_to_membership_list'">
            <div v-show="(data.old == true && data.new == '0') || (data.old == false && data.new == '1')"
              class="p-3 bg-light-gray rounded-xl">
              <p class="pb-2">{{ formatTitleString(data.key) }}</p>
              <div class="grid grid-cols-2">
                <div class="text-gray line-through">{{ data.old }}</div>
                <div class="text-blue">
                  <div v-if="data.new == 0">false</div>
                  <div v-else>true</div>
                </div>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="p-3 bg-light-gray rounded-xl">
              <p class="pb-2">{{ formatTitleString(data.key) }}</p>
              <div class="grid grid-cols-2">
                <div class="text-gray">
                  <div v-if="data.old">
                    <div v-if="data.key == 'social_medias'">
                      <div v-for="(socialMedia, index) in data.old" :key="index">
                        <a :href="socialMedia.url" target="_blank" class="text-gray underline">
                          Old {{ socialMedia.title }} link</a>
                      </div>
                    </div>
                    <div v-else class="line-through">{{ data.old }}</div>
                  </div>
                  <div v-else>
                    N/A
                  </div>
                </div>
                <div class="text-blue">
                  <div v-if="data.new">
                    <div v-if="data.key == 'social_medias'">
                      <div v-for="(socialMedia, index) in Object.entries(data.new)" :key="index">
                        <a v-if="socialMedia[1]" :href="socialMedia[1]" target="_blank" class="text-blue underline">
                          New {{ socialMedia[0] }} link</a>
                          <p v-else>N/A</p>
                      </div>
                    </div>
                    <div v-else>{{ data.new }}</div>
                  </div>
                  <div v-else>
                    N/A
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </SideBar>
</template>

<script>
import { Menu, MenuButton, MenuItems, MenuItem } from "@headlessui/vue";
import {
  MagnifyingGlassIcon,
  EllipsisVerticalIcon,
  UserPlusIcon,
  UserMinusIcon,
  EyeIcon,
} from "@heroicons/vue/24/outline";
import { InboxIcon } from "@heroicons/vue/24/solid";
import userService from "../Services/user.service";
import BasePagination from "../components/BasePagination.vue";
import { useToast } from "vue-toastification";
import moment from "moment";
import SideBar from "../components/SideBar.vue";
import BaseTextInput from "../components/BaseTextInput.vue";
import BaseRoundedButton from "../components/BaseRoundedButton.vue";
export default {
  components: {
    MagnifyingGlassIcon,
    EllipsisVerticalIcon,
    Menu,
    MenuButton,
    MenuItems,
    MenuItem,
    BasePagination,
    UserPlusIcon,
    UserMinusIcon,
    InboxIcon,
    SideBar,
    BaseTextInput,
    BaseRoundedButton,
    EyeIcon,
  },
  setup() {
    const toast = useToast();
    return { toast };
  },
  data() {
    return {
      isLoading: true,
      rejectSlideOver: false,
      viewSlideOver: false,
      members: [],
      membersMeta: [],
      params: new URLSearchParams(),
      searchText: "",
      reason: "",
      note: "",
      tempData: "",
    };
  },
  methods: {
    getMember() {
      this.params.set("is_request_update", "1");
      userService.getMembers(this.params).then((response) => {
        this.members = response.data.data;
        this.membersMeta = response.data.meta;
        this.isLoading = false;
      });
    },
    handleConfirmUpdate(memberId) {
      this.$Progress.start();
      userService
        .storeConfirmUpdate(memberId)
        .then(() => {
          this.$Progress.finish();
          this.getMember();
          this.getDashBoardSummray();
          this.toast.success("Update confrimed.");
        })
        .catch(() => {
          this.$Progress.fail();
          this.toast.error("Something went wrong! Could not confirm.");
        });
    },
    handleRejectSlideOver(data) {
      this.rejectSlideOver = !this.rejectSlideOver;
      this.tempData = data;
    },
    handleRejectUpdate() {
      this.$Progress.start();
      let formData = new FormData();
      formData.append("reason", this.reason);
      formData.append("note", this.note);

      userService
        .storeRejectUpdate(this.tempData, formData)
        .then(() => {
          this.$Progress.finish();
          this.reason = "";
          this.note = "";
          this.tempData = "";
          this.getMember();
          this.getDashBoardSummray();
          this.handleRejectSlideOver("");
          this.toast.success("Reject update success");
        })
        .catch(() => {
          this.$Progress.fail();
          this.toast.error("Something went wrong! Could not reject update.");
        });
    },
    handleSearch() {
      this.params.set("search", this.searchText);
      this.getMember(this.params.toString());
    },
    handlePagination(value) {
      this.params.set("page", value);
      this.getMember(this.params.toString());
    },
    getDashBoardSummray() {
      userService.getDashboard().then((response) => {
        this.$store.commit("setInboxCount", response.data.unread_inbox);
        this.$store.commit("setNotificationCount", response.data.unread_notification);
        this.$store.commit("setMemberRequestCount", response.data.new_member_request);
        this.$store.commit("setRequestUpdateCount", response.data.member_request_update);
      });
    },
    handleViewSlideOver(data) {
      let oldData = data
      let newData = data.request_change_info

      // compare newData and oldData and return the difference in an array of object with key and value of old and new data
      let result = Object.keys(newData).reduce((acc, key) => {
        if ((newData[key] !== oldData[key]) && (key !== 'social_medias')) {
          acc.push({
            key,
            old: oldData[key],
            new: newData[key],
          });
        } else if (key === 'social_medias') {
          // // social_medias is oldData format is [{name: 'facebook', link: 'https://facebook.com'}, {name: 'instagram', link: 'https://instagram.com'}] so format it to {facebook: 'https://facebook.com', instagram: 'https://instagram.com'}
          let oldSocialMedias = oldData.social_medias.reduce((acc, socialMedia) => {
            acc[socialMedia.title] = socialMedia.url
            return acc
          }, {})
          console.log(oldSocialMedias)
          console.log(newData.social_medias)

          let isDifferent = Object.keys(newData.social_medias).some((key) => {
            return newData.social_medias[key] !== oldSocialMedias[key]
          })

          if (isDifferent) {
            acc.push({
              key: 'social_medias',
              old: oldSocialMedias,
              new: newData.social_medias,
            });
          }
        }
        return acc;
      }, []);
      this.tempData = result;
      this.viewSlideOver = true;
    },
    handleCloseViewSlideOver() {
      this.viewSlideOver = false;
      this.tempData = null;
    },
    formatTitleString(string) {
      return string
        .split("_")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
    },
  },
  created() {
    this.$Progress.start();
    this.moment = moment;
    this.getMember();
  },
  mounted() {
    this.$Progress.finish();
  },
};
</script>

<style scoped></style>